import { getRefElement } from '../../utils';
import { useEventCallback } from '../useEventCallback';
/**
 * group hidden logic, when binding events element focus,
 * that hiddenRef will auto be `tabindex={-1}` *
 */
export var useHiddenTabindex = function (target) {
    var handleFocus = useEventCallback(function () {
        var hiddenElm = getRefElement(target);
        if (hiddenElm && hiddenElm.tabIndex === 0) {
            hiddenElm.tabIndex = -1;
        }
    });
    var handleBlur = useEventCallback(function () {
        var hiddenElm = getRefElement(target);
        if (hiddenElm && hiddenElm.tabIndex === -1) {
            hiddenElm.tabIndex = 0;
        }
    });
    return {
        onFocus: handleFocus,
        onBlur: handleBlur,
    };
};
